import React, { useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { NavLink } from "react-router-dom";

export default function UnrecogTable({
	className,
	headers = [
		{
			header_name: "Column 1",
			header_key: "column1",
		},
		{
			header_name: "Column 2",
			header_key: "column2",
		},
	],
	items = [
		{
			column1: "Column 2",
			column2: "Column 2",
		},
	],
	children,
	linkName,
	linkBody,
	fieldId,
	actionColumn,
	bottomAction,
	dt,
}) {
	const [pastItem, setPastItem] = React.useState([]);
	const withLinkTemplate = (rowData) => {
		return (
			<NavLink
				to={`${linkBody}/${rowData[fieldId]}`}
				className={"text-component-blueTextColor"}
			>
				{rowData[linkName]}
			</NavLink>
		);
	};

	//rowColors
	const rowClassName = (rowData) => {
		if (rowData.status === "Claimed") {
			return "bg-green-300 border border-black";
		} else if (rowData.status === "Revoked") {
			return "bg-red-300 border border-black";
		} else if (rowData.status === "Removed") {
			return "bg-gray-300 border border-black";
		} else if (rowData.status === "Pending") {
			return "bg-yellow-300 border border-black";
		} else if (rowData.status === "Take-Back") {
			return "bg-blue-300 border border-black";
		} else if (rowData.status === "Revoked") {
			return "bg-red-300 border border-black";
		} else if (rowData.status === "Cancelled") {
			return "bg-amber-400 border border-black";
		}
		return "border border-black";
	};

	return (
		<DataTable
			value={items}
			paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
			currentPageReportTemplate="Rows per page"
			paginator
			paginatorRight
			rowsPerPageOptions={[10, 20, 50]}
			rows={10}
			sortMode="multiple"
			className="border border-black"
			removableSort
			rowClassName={rowClassName}
			exportFilename="Unrecognized Waybill Report"
			showGridlines
			tableStyle={{
				minWidth: "50rem",
				borderWidth: 2,
				borderColor: "#E6E6E6",
			}}
			emptyMessage={<div></div>}
			ref={dt}
			cellSelection={true}
			onCellClick={(e) => {
				if (e.field == "waybill") {
					window.open(
						`/operator/admin/view-package-history/${e.rowData.packageId}/${e.rowData.userId}`,
						"_blank"
					);
				}
				if (e.field == "courier") {
					window.open(
						`/operator/admin/agents/agentProfile/${e.rowData.agentId}`,
						"_blank"
					);
				}
				if (e.field == "recipient") {
					window.open(
						`/operator/admin/locker-user-accounts/user-profile-page/${e.rowData.userAccountId}`,
						"_blank"
					);
				}
			}}
		>
			{headers.map((data, key) => {
				if (data.header_key == "blank") {
					return (
						<Column
							field={data.header_key}
							header={data.header_name}
							style={{ display: "none" }}
						></Column>
					);
				}
				// console.log(linkName, data.header_key);
				if (linkBody && linkName === data.header_key) {
					return (
						<Column
							field={data.header_key}
							sortable
							header={data.header_name}
							body={withLinkTemplate}
							headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
						></Column>
					);
				}
				if (data.header_key == "recipient") {
					return (
						<Column
							field={data.header_key}
							sortable
							className="font-blue cursor-pointer font-bold"
							header={data.header_name}
							body={formatDate1}
							headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
						></Column>
					);
				}
				if (data.header_key == "courier") {
					return (
						<Column
							field={data.header_key}
							sortable
							header={data.header_name}
							className="font-blue cursor-pointer font-bold"
							body={formatDate2}
							headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
						></Column>
					);
				}
				if (data.header_key == "dropoff") {
					return (
						<Column
							field={data.header_key}
							sortable
							header={data.header_name}
							body={formatDate01}
							headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
						></Column>
					);
				}
				if (data.header_key == "statusDate") {
					return (
						<Column
							field={data.header_key}
							sortable
							header={data.header_name}
							body={formatDate00}
							headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
						></Column>
					);
				}
				if (data.header_key == "waybill") {
					return (
						<Column
							field={data.header_key}
							className="font-blue cursor-pointer font-bold"
							sortable
							header={data.header_name}
							body={removeSecondA}
							headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
						></Column>
					);
				}
				return (
					<Column
						field={data.header_key}
						sortable
						header={data.header_name}
						headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
					></Column>
				);
			})}
		</DataTable>
	);
}

const formatDate1 = (e) => {
	return e.recipient.toString().substring(2);
};

const formatDate2 = (e) => {
	return e.courier.toString().substring(2);
};

const formatDate00 = (e) => {
	if (e.statusDate == null) {
		return "";
	}
	const date = new Date(e.statusDate.split(" ")[0]);
	const options = {
		year: "numeric",
		month: "short",
		day: "numeric",
	};
	return `${date.toLocaleDateString(undefined, options)} at ${
		e.statusDate.split(" ")[1]
	} `;
};
const formatDate01 = (e) => {
	if (e.dropoff == null) {
		return "";
	}
	const date = new Date(e.dropoff.split(" ")[0]);
	const options = {
		year: "numeric",
		month: "short",
		day: "numeric",
	};
	return `${date.toLocaleDateString(undefined, options)} at ${
		e.dropoff.split(" ")[1]
	} `;
};

const removeSecondA = (e) => {
	if (e.waybill.length < 2) {
		return e.waybill;
	}
	if (e.waybill.charAt(1) === "*") {
		return e.waybill.slice(0, 1) + e.waybill.slice(2);
	}
	return e.waybill;
};
